const i18n = {
  'login': {
    'form': {
      'email': '電子郵件地址',
      'password': '密碼',
      'confirmPassword': '確認密碼',
      'login': '登入',
      'signup': '註冊',
      'submit': '送出',
      'resetPassword': '重設密碼',
      'forgotPassword': '忘記密碼？',
      'loginPage': '登入頁面',
      'resetPasswordMessage': '請至信箱收信並重設密碼',
      'activateAccountMessage': '請至信箱收信以啟用帳號',
    },
    'error': {
      'email': '電子郵件錯誤',
      'password': '密碼錯誤',
      'emptyEmail': '電子郵件為必填',
      'emptyPassword': '密碼為必填',
      'confirmPassword': '兩次輸入的密碼不同',
      'notActivatedAccount': '帳號尚未啟用',
    }
  }
};
export default i18n;
